import { render } from "./articleDetails.vue?vue&type=template&id=49d1f7b0&scoped=true"
import script from "./articleDetails.vue?vue&type=script&lang=js"
export * from "./articleDetails.vue?vue&type=script&lang=js"

import "./articleDetails.vue?vue&type=style&index=0&id=49d1f7b0&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d1f7b0"]])

export default __exports__